var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmarkDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5889 6.34932C14.1357 5.81221 14.1357 4.93994 13.5889 4.40283C13.042 3.86572 12.1539 3.86572 11.607 4.40283L7.00011 8.93174L2.38886 4.40713C1.84198 3.87002 0.953857 3.87002 0.406982 4.40713C-0.139893 4.94424 -0.139893 5.8165 0.406982 6.35361L5.01823 10.8782L0.411357 15.4071C-0.135518 15.9442 -0.135518 16.8165 0.411357 17.3536C0.958232 17.8907 1.84636 17.8907 2.39323 17.3536L7.00011 12.8247L11.6114 17.3493C12.1582 17.8864 13.0464 17.8864 13.5932 17.3493C14.1401 16.8122 14.1401 15.9399 13.5932 15.4028L8.98198 10.8782L13.5889 6.34932Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkDark);
export default __webpack_public_path__ + "static/media/xmark-dark.0c428ce98582b7970c5f9885f4fe1dbd.svg";
export { ForwardRef as ReactComponent };